<template>
  <el-timeline style="margin-top:20px;">
    <el-timeline-item :timestamp="getByIdFullData.createtime" placement="top">
      <div>
        <div>处理人：{{getByIdFullData.creatuser}}</div>
        <div>状态：提交举报信息</div>
      </div>
    </el-timeline-item>
    <el-timeline-item
      :timestamp="item.createtime"
      placement="top"
      v-for="(item,index) in resultFlow"
      :key="index"
    >
      <div>
        <div>处理人：{{item.flowusername}}</div>
        <div>
          状态：
          <span v-if="item.status">{{item.status|flowListName}}</span>
          <span v-else>{{item.result}}</span>
        </div>
      </div>
      <div style="background-color: rgba(246, 255, 237, 1);
        border: 1px solid rgba(183, 235, 143, 1);
        color: #52C41A;
        display: inline-block;
        margin: 16px 0;"
        v-if="item.sendwechar">
        {{item.sendwechar}}
      </div>
      <br>
      <div style="background-color: rgba(246, 255, 237, 1);
        border: 1px solid rgba(183, 235, 143, 1);
        color: #52C41A;
        display: inline-block;
        margin: 16px 0;"
        v-if="item.sendmail">
        {{item.sendmail}}
      </div>
    </el-timeline-item>
  </el-timeline>
</template>
<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import { fetchGet, fetchPost } from "@/libs/reqCommon";
import { bubbleSort } from "@/libs/commonMethod";
import { ifEvaluate } from "@/libs";

export default {
  props: {
    unCheck: {
      type: Array,
      default: () => {
        return [0, 7, 9];
      },
    },
  },
  data() {
    return {
      resultFlow: [],
    };
  },
  created() {
    this.getFlowList();
  },
  computed: {
    ...mapGetters(["getByIdFullData"]),
  },
  methods: {
    getFlowList() {
      console.log(this.getByIdFullData)
      this.getByIdFullData.createtime = this.$options.filters["fullTime"](
        this.getByIdFullData.createtime
      );
      this.flowList = this.getByIdFullData.flowList.filter(
        (item, index, arr) => {
          return this.unCheck.indexOf(item.status) == -1;
        }
      );
      this.getByIdFullData.resultlist.map(item=>{
        item.result=item.result
      })
      let lastFlowList = bubbleSort(
        this.flowList.concat(this.getByIdFullData.resultlist),
        "createtime"
      ); //按照时间排序
      lastFlowList.map((item, index) => {
        item.createtime = this.$options.filters["fullTime"](item.createtime);
      });
      if (ifEvaluate(this.getByIdFullData.flowList)) {
        //申诉合理
        lastFlowList.splice(2, 0, {
          status: 14,
          createtime: lastFlowList[2]
            ? lastFlowList[2].createtime
            : this.$options.filters["fullTime"](
                this.getByIdFullData.updatetime
              ),
          flowusername: lastFlowList[2]
            ? lastFlowList[2].flowusername
            : this.getByIdFullData.flowusername,
        });
      }
      this.resultFlow = lastFlowList;
    },
  },
};
</script>
